/**
// * ============================================================
// * VALIDACIONES DE CATÁLOGOS – SALVIR
// * ============================================================
 
 //* El frontend solo valida existencia para mejorar UX.
 //*
 //*
 //*
 //*/

// AGREGAR en catalogos.js

// Servicios permitidos para médico general (tipoPersonal = 2)

// Validaciones de edad por servicio
export const validarEdadServicio = (catalogKey, edadPaciente,cluesEsServicioAmigable = false) => {
    const key = String(catalogKey);
    const edad = parseFloat(edadPaciente);
    if (key === "16" && edad >= 18) return false;
    if ((key === "39" || key === "62") && edad < 60) return false;
    if (key === "22" && !(edad >= 10 && edad <= 19)) return false;
     if (key === "22" && !cluesEsServicioAmigable) return false;
    return true;
};

// ============================================================
// REGLAS GEOGRÁFICAS NOM-024 — PAÍS / ENTIDAD / MUNICIPIO / LOCALIDAD
// ============================================================
//
// Estas funciones implementan la tabla de relación geográfica
// definida en la NOM-024 para el catálogo de ubicación.
//
// REGLA GENERAL:
// - País ≠ México (142) → entidad, municipio y localidad = "NO APLICA"
// - País = México (142) → se escoge del catálogo, pero existen
//   valores especiales (SE IGNORA, NO ESPECIFICADO) que fuerzan
//   valores dependientes según la tabla.
// ============================================================

// Claves fijas NOM-024
const GEO_NO_APLICA = {
  entidad: "88",
  municipio: "997",
  localidad: "9997",
};

const GEO_SE_IGNORA = {
  entidad: "99",
  municipio: "998",
  localidad: "9998",
};

const GEO_NO_ESPECIFICADO = {
  entidad: "00",
  municipio: "999",
  localidad: "9999",
};

/**
 * valoresGeoPorPais
 * ------------------------------------------------------------
 * Dado un país seleccionado, devuelve los valores que deben
 * asignarse a entidad, municipio y localidad.
 *
 * - Si no hay país (null) → todo null (no ha escogido nada)
 * - Si país ≠ 142 → NO APLICA (88, 997, 9997)
 * - Si país = 142 → null (el usuario debe escoger del catálogo)
 */
export const valoresGeoPorPais = (paisKey) => {
  // No ha escogido nada
  if (!paisKey) {
    return { entidad: null, municipio: null, localidad: null };
  }

  const esMexico = String(paisKey) === "142";

  if (!esMexico) {
    return { ...GEO_NO_APLICA };
  }

  // México: el usuario escoge desde los dropdowns
  return { entidad: null, municipio: null, localidad: null };
};

/**
 * valoresGeoPorEntidad
 * ------------------------------------------------------------
 * Dada una entidad seleccionada, devuelve los valores que
 * deben asignarse a municipio y localidad.
 *
 * - Entidad "99" (SE IGNORA) → municipio 998, localidad 9998
 * - Entidad "00" (NO ESPECIFICADO) → municipio 999, localidad 9999
 * - Cualquier otra → null (el usuario escoge del catálogo)
 * - Sin entidad (null) → null
 */
export const valoresGeoPorEntidad = (entidadKey) => {
  if (!entidadKey) {
    return { municipio: null, localidad: null };
  }

  const key = String(entidadKey);

  if (key === GEO_SE_IGNORA.entidad) {
    return { municipio: GEO_SE_IGNORA.municipio, localidad: GEO_SE_IGNORA.localidad };
  }

  if (key === GEO_NO_ESPECIFICADO.entidad) {
    return { municipio: GEO_NO_ESPECIFICADO.municipio, localidad: GEO_NO_ESPECIFICADO.localidad };
  }

  // Entidad normal: el usuario escoge municipio del catálogo
  return { municipio: null, localidad: null };
};

/**
 * valoresGeoPorMunicipio
 * ------------------------------------------------------------
 * Dado un municipio seleccionado, devuelve el valor que
 * debe asignarse a localidad.
 *
 * - Municipio "998" (SE IGNORA) → localidad 9998
 * - Municipio "999" (NO ESPECIFICADO) → localidad 9999
 * - Cualquier otro → null (el usuario escoge del catálogo)
 * - Sin municipio (null) → null
 */
export const valoresGeoPorMunicipio = (municipioKey) => {
  if (!municipioKey) {
    return { localidad: null };
  }

  const key = String(municipioKey);

  if (key === GEO_SE_IGNORA.municipio) {
    return { localidad: GEO_SE_IGNORA.localidad };
  }

  if (key === GEO_NO_ESPECIFICADO.municipio) {
    return { localidad: GEO_NO_ESPECIFICADO.localidad };
  }

  // Municipio normal: el usuario escoge localidad del catálogo
  return { localidad: null };
};

/**
 * esEntidadEspecial
 * ------------------------------------------------------------
 * Indica si la entidad seleccionada es un valor especial
 * (SE IGNORA o NO ESPECIFICADO) que no requiere mostrar
 * dropdown de municipio.
 */
export const esEntidadEspecial = (entidadKey) => {
  const key = String(entidadKey);
  return key === GEO_SE_IGNORA.entidad || key === GEO_NO_ESPECIFICADO.entidad;
};

/**
 * esMunicipioEspecial
 * ------------------------------------------------------------
 * Indica si el municipio seleccionado es un valor especial
 * (SE IGNORA o NO ESPECIFICADO) que no requiere mostrar
 * dropdown de localidad.
 */
export const esMunicipioEspecial = (municipioKey) => {
  const key = String(municipioKey);
  return key === GEO_SE_IGNORA.municipio || key === GEO_NO_ESPECIFICADO.municipio;
};


// Validación de establecimiento especializado para primeraVezUneme
export const esEstablecimientoEspecializadoUNEME = (establecimiento) => {
  if (!establecimiento) return false;

  const tip = String(establecimiento.tip_abreviacion || "").trim().toUpperCase();
  const sub = String(establecimiento.sub_abreviacion || "").trim().toUpperCase();

  const tipValido = tip === "T" || tip === "UNE";
  const subValido = ["T02", "UNE02", "UNE04", "UNE11"].includes(sub);

  return tipValido && subValido;
};